import React, { useEffect, useRef, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import SimpleReactValidator from 'simple-react-validator'
import draftToHtml from 'draftjs-to-html'
import MainLoading from '../../../../utils/MainLoading'
import htmlToDraft from 'html-to-draftjs'
import { fetchEthics } from '../../../../redux/action/ethics/Ethics'
import { fetchCreateEthics, fetchEditEthics } from '../../../../redux/action/ethics/createEthics'
import { useTranslation } from 'react-i18next';

const Ethics = () => {
    const {t} = useTranslation();
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const dispatch = useDispatch()
    const ethics_info = useSelector(state => state.ethics_info)
    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const [data, setData] = useState({
        title: '',
        type: 1
    })

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    useEffect(() => {
        if(!ethics_info.ethics_info.id) {
            dispatch(fetchEthics())
        }
    }, [])

    useEffect(() => {
        const blocksFromHtml = htmlToDraft(ethics_info.ethics_info.description ? ethics_info.ethics_info.description : '');
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        setData({
            title: ethics_info.ethics_info.title ? ethics_info.ethics_info.title: '' ,
        })
        setEditorState(EditorState.createWithContent(contentState))
    }, [ethics_info.ethics_info])

    const handleDataChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
    };

    const handleFromSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            const ethics_page = {
                title: data.title,
                type: 2,
                description: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            }
            dispatch(fetchCreateEthics(ethics_page))
            window.scrollTo(0, 0)
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    const handleEditPage = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setBtnLoading(false)
            const privacy_page = {
                title: data.title,
                description: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            }
            dispatch(fetchEditEthics(privacy_page))
            window.scrollTo(0, 0)
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    return (
        <div className='mt-5'>
            {ethics_info.loading ?
                <MainLoading />
            :
                <Form className='col-lg-12'>
                    <Form.Group className="mb-3 col-lg-7" controlId="formTitle">
                        <Form.Label>{t("page title")} :</Form.Label>
                        <Form.Control type="text" name="title" value={data.title} onChange={handleDataChange}  />
                        <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                    </Form.Group>
                    <Form.Group className="mb-3 col-lg-7" controlId="formDescription">
                        <Form.Label>{t("text")} :</Form.Label>
                        <Editor
                            editorState={editorState}
                            wrapperClassName="texteditor-wrapper"
                            editorClassName="texteditor-editor"
                            onEditorStateChange={onEditorStateChange}
                        />  
                        <span className='validator_error'>{validator.current.message('title', data.title, 'required')}</span>
                    </Form.Group>
                    {ethics_info.ethics_info.title ?
                        <Button variant="success" type="submit" className='px-4 mt-2' onClick={handleEditPage} disabled={btnLoading ? true : false}>
                            {t("edit")}
                        </Button>
                    :
                        <Button variant="success" type="submit" className='px-4 mt-2' onClick={handleFromSubmit} disabled={btnLoading ? true : false}>
                            {t("submit")}
                        </Button>
                    }
                </Form>
            }
        </div>
    )
}

export default Ethics
